import { createContext, useContext } from 'react'
type context = {
   anchorButton: string[]
   setAnchorButton: (anchorButton: string[]) => void
}

const AnchorButtonContext = createContext<context>({
   anchorButton: [],
   setAnchorButton: (anchorButton) => anchorButton,
})
export const useAnchorButtonContext = () => useContext(AnchorButtonContext)
export default AnchorButtonContext
